/**
 * 后台的稿件详情页 把四种稿件全部整合到一个文件中
 * 2017-12-6
 */
"use strict";
angular.module("documentDetailModule", ["documentDetailRouter"]).
controller("documentDetailCtrl", ["$scope", "$element", "$compile", "$timeout", "$q", "httpService", '$filter', '$stateParams', '$sce', 'backArticleService', 'modalDialog', 'localStorageService', 'playVideoService', function($scope, $element, $compile, $timeout, $q, httpService, $filter, $stateParams, $sce, backArticleService, modalDialog, localStorageService, playVideoService) {
	initStatus();
	initData();
	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.status = {
			isShowTimeDetal: false, //是否显示时间详情
			isBackstage: true, //区分后台和前台
			isReview: $stateParams.isReview //稿件是否已经签发
		};
		$scope.data = {};
		$scope.simpleMode = {};
		$scope.calendar = {};
		$scope.listData = [];
		$scope.params = {
			articleId: $stateParams.articleId,
			channelId: $stateParams.channelId,
		}
	};
	/**
	 * [initStatus description] 初始化数据
	 */
	function initData() {
		$("html").css('backgroundColor', '#F5F7FA');
		getAuthority().then(function() {
			requestData().then(function() {

			});
		});
	};
	/**
	 * [requestData description] 初始化列表数据
	 */
	function requestData() {
		var deffer = $q.defer();
		$scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcArticle/findById.do", $scope.params, "get").then(function(data) {
			$scope.listData = data.data;
			$scope.listData.articleHtmlCon = $sce.trustAsHtml(data.data.articleHtmlCon);
			//活动搞
			if(data.data.articleType == 3) {
				$scope.taginfo = data.channelInfo; //初始化标签信息
				initActivityDateAndTime(); //初始化活动日期和时间
			}
			//图集稿
			if(data.data.articleType == 1) {
				$scope.pictures = JSON.parse(data.data.pictures);
				$scope.selectedPicInfo = $scope.pictures[0];
			}
			//视频稿
			if(data.data.articleType == 2) {
				$scope.videos = JSON.parse(data.data.videos);
				getVideoImage();
			}
			//每种稿件都要加载渠道信息 所以写在最下面
			var imgs = data.data.coverImg;
			var imgss = imgs.substring(1, imgs.length - 1).split(',');
			$scope.imgArray = [];
			for(var i = 0; i < imgss.length; i++) {
				if(imgss[i] !== 'null') {
					$scope.imgArray.push(imgss[i].substring(1, imgss[i].length - 1));
				}
			}
			deffer.resolve();
		});
		return deffer.promise;
	};
	/**
	 * [initActivityDateAndTime description] 初始化活动日期和时间
	 * @return {[type]} [description]
	 */
	function initActivityDateAndTime() {
		$scope.listData.activityTime = JSON.parse($scope.listData.activityTime);
		if($scope.listData.activityTimeMode === 1) { //日历模式
			initCalendarData().then(function() {
				loadDateSlider();
			});
		} else { //简单模式
			$scope.simpleMode.startDate = $filter("date")($scope.listData.activityTime.date[0], 'yyyy年MM月dd日');
			$scope.simpleMode.endDate = $filter("date")($scope.listData.activityTime.date[1], 'yyyy年MM月dd日');
			$scope.simpleMode.startTime = $scope.listData.activityTime.time[0];
			$scope.simpleMode.endTime = $scope.listData.activityTime.time[1];
		}
	}
	/**
	 * [initCalendarData description] 初始化日历数据
	 * @return {[type]} [description]
	 */
	function initCalendarData() {
		var deffer = $q.defer();
		$scope.calendar.data = $scope.listData.activityTime[0];
		$scope.calendar.data.sort(function(x, y) {
			return x.start - y.start;
		});
		$scope.calendar.startDate = $filter("date")($scope.calendar.data[0].start, "yyyy年MM月dd日");
		var tempData = angular.copy($scope.calendar.data);
		tempData.sort(function(x, y) {
			return y.end - x.end;
		});
		$scope.calendar.endDate = $filter("date")(tempData[0].end, "yyyy年MM月dd日");
		var tempObject = {};
		for(var i in $scope.calendar.data) {
			var theDate = $scope.calendar.data[i];
			var attribute = theDate.start + "-" + theDate.end;
			if(!tempObject[attribute]) {
				tempObject[attribute] = [theDate];
			} else {
				tempObject[attribute].push(theDate);
			}
		}
		var tempArray = [];
		for(var j in tempObject) {
			tempArray.push(tempObject[j]);
		}
		tempArray.sort(function(x, y) {
			return x[0].start - y[0].start;
		});
		$timeout(function() {
			$scope.calendar.data = tempArray;
			deffer.resolve();
		});
		return deffer.promise;
	}
	/**
	 * [loadDateSlider description] 初始化日期滑动组件
	 * @return {[type]} [description]
	 */
	function loadDateSlider() {
		var $dateSlider = $(document.createElement("date-slider"));
		$dateSlider.attr({
			"date-array": "calendar.data",
			"callback": "dateRangeSelect()",
			"selected-date-range": "calendar.selectedDateRange"
		});
		$dateSlider = $compile($dateSlider)($scope);
		$element.find(".dateSlider").append($dateSlider);
	}
	/**
	 * [dateRangeSelect description] 选择时间段回调函数
	 * @return {[type]} [description]
	 */
	$scope.dateRangeSelect = function() {
		$timeout(function() {
			$scope.calendar.selectedDateRange_ = angular.copy($scope.calendar.selectedDateRange);
			delete $scope.calendar.selectedDateRange_.$$hashKey;
			delete $scope.calendar.selectedDateRange_.dateRange;
		});
	};
	/**
	 * [handleSelectedDateRange description] 处理选中时间段数据
	 * @param {[object]} [item] [description] 时间段
	 * @return {[type]} [description]
	 */
	$scope.handleSelectedDateRange = function(item) {
		var date = new Date(item.start);
		item.day = getDayZH(date.getDay());
		item.date = "(" + $filter("date")(date, "MM月dd日") + ")";
		item.timeRange = item.startEndTime[0] + "-" + item.startEndTime[1];
	};
	/**
	 * [getDay description] 获取星期数中文
	 * @return {[type]} [description]
	 */
	function getDayZH(day) {
		var dayZh;
		switch(day) {
			case 0:
				dayZh = "周日";
				break;
			case 1:
				dayZh = "周一";
				break;
			case 2:
				dayZh = "周二";
				break;
			case 3:
				dayZh = "周三";
				break;
			case 4:
				dayZh = "周四";
				break;
			case 5:
				dayZh = "周五";
				break;
			case 6:
				dayZh = "周六";
				break;
			default:
				dayZh = "未知";
		}
		return dayZh;
	};
	/**
	 * [getAuthority description] 获取权限
	 * @return {[type]} [description]
	 */
	function getAuthority() {
		var deffer = $q.defer();
		httpService.http("/mcnadmin/admin/auth/getCurrUserAuthInfo.do", "", "post").
		then(function(data) {
			$scope.data.authority = data.data;
			$scope.$root.authority = $scope.data.authority;
			deffer.resolve();
		});
		return deffer.promise;
	};
	/**
	 * [queryByDropdown description] 签发稿件
	 * @param  {[type]} key   [description] 稿件的ID
	 * @return {[type]}       [description] null
	 */
	$scope.issueArticle = function() {
		modalDialog.backConfirmModal("签发", "确认签发此稿件？", function() {
			$scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcArticle/issueArticle.do", $scope.params, "post").then(function(data) {
				reFreshListPage();
				modalDialog.alertType('', '签发成功', 'success', false, function() {
					window.close();
				});
			});
		});
	}
	/**
	 * [queryByDropdown description] 退回稿件
	 * @param  {[type]} key   [description] 稿件的ID
	 * @return {[type]}       [description] null
	 */
	$scope.backArticle = function() {
		backArticleService.backArticle().then(function(data) {
			var params = {
				articleId: $scope.params.articleId,
				remark: data,
				channelId: $scope.params.channelId,
			}
			$scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcArticle/backArticle.do", params, "post").then(function(data) {
				reFreshListPage();
				modalDialog.alertType('', '退回成功', 'success', false, function() {
					window.close();
				});
			});
		});
	}
	/**
	 * [downlineArticle description]强制下线
	 * @param  {[type]} key   [description] 稿件的id
	 * @return {[type]} [description]
	 */
	$scope.downlineArticle = function() {
		modalDialog.backConfirmModal("下线", "确认下线此文章？", function() {
			$scope.loadingPromise = httpService.http("/mcnadmin/admin/pgcArticle/downlineArticle.do", $scope.params, "post").then(function(data) {
				reFreshListPage();
				modalDialog.alertType('', '下线成功', 'success', false, function() {
					window.close();
				});
			});
		});
	}
	//获取播放视频的图片
	function getVideoImage() {
		httpService.http("/mcnadmin/web/cloud/getMediaFrame.do", {
			// mediaId: $scope.videos[0].id
			id: $scope.videos[0].id,
			libType:101
		}, "get").then(function(data) {
			$scope.videoImageUrl = data.data.mediaFrameUrl;
		});
	}
	$scope.openVideo = function() {
		playVideoService.openPlayVideoPage($scope.videos[0].id, 'video', true);
	}
	/**
	 * [reFreshList description] 刷新列表页
	 * @return {[type]} [description]
	 */
	function reFreshListPage() {
		localStorageService.set("refresh", Math.random());
	}
}]);